const API_ENDPOINTS = {
  dev: 'https://dev-api-user-management.intaiq.com/api/v1',
  stage: 'https://stage-api.domain.com/api/v1',
  prod: 'https://prod-api.domain.com/api/v1',
  local: 'http://localhost:8000/api/v1'
};

export const API_KEY = 'B19Jf5t6i9W54wbQQ6bKUocwvbyOjuS9jaKDLKl8';

export const getApiBaseUrl = (env = (typeof process !== 'undefined' && process.env && process.env.API_ENV) || 'dev') => {
  return API_ENDPOINTS[env] || API_ENDPOINTS.dev;
};

export default {
  getApiBaseUrl,
  API_ENDPOINTS
};
